import { useMutation, useQueryClient } from 'react-query';
import { restoreSwipe, type RestoreSwipeResponse } from '../../services/findBuddyService';

export function useRestoreSwipe() {
  const queryClient = useQueryClient();
  return useMutation<RestoreSwipeResponse, Error, { adUnitId: string }>({
    mutationFn: ({ adUnitId }) => restoreSwipe(adUnitId),
    onSuccess: () => {
      queryClient.invalidateQueries(['MyBuddyPreferenceQuery']);
    }
  });
}
